module.exports = __webpack_public_path__ + "media/avisos/notificacao-min-cb91c162.jpg";